import { render } from "./App.vue?vue&type=template&id=68dcebae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=68dcebae&lang=css"

import exportComponent from "/Users/ginea/Desktop/template_demo/vuejs-tailwindcss-portfolio-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__